import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DynamicFormComponent } from "../../common/dynamic-form/dynamic-form.component";
import { FileUploadComponent } from "../../common/file-upload/file-upload.component";

@Component({
  selector: "app-generate-mapping-modal",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DynamicFormComponent, FileUploadComponent],
  templateUrl: "./generate-mapping-modal.component.html",
  styleUrl: "./generate-mapping-modal.component.scss",
})
export class GenerateMappingModalComponent {
  @Input()
  configs: any = {};

  @Input()
  fields: any = [];

  model: any = {};

  activeModal = inject(NgbActiveModal);
  dynamicForm: any = new FormGroup({});
  mappingNameControl = new FormControl('', [Validators.required]);
  testCasesFileControl = new FormControl('', [Validators.required]);
  isActive: boolean = false;
  isDragOver: boolean = false;
  selectedFile: File | null = null;

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (this.isValidFileType(file)) {
        this.processFile(file);
      } else {
        this.testCasesFileControl.setErrors({ invalidFileType: true });
        this.testCasesFileControl.markAsTouched();
      }
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (this.isValidFileType(file)) {
        this.processFile(file);
      } else {
        this.testCasesFileControl.setErrors({ invalidFileType: true });
        this.testCasesFileControl.markAsTouched();
      }
    }
  }

  private isValidFileType(file: File): boolean {
    const fileName = file.name.toLowerCase();
    return fileName.endsWith('.csv');
  }

  private processFile(file: File): void {
    this.selectedFile = file;
    this.testCasesFileControl.setValue(file.name);
    this.testCasesFileControl.setErrors(null);
    this.testCasesFileControl.markAsTouched();
  }

  handleFilesSelected(event: any): string {
    if (event?.files && event.files.length > 0) {
      const fileNames = event.files.map((file: File) => file.name).join(', ');
      this.testCasesFileControl.setValue(fileNames);
      return fileNames;
    }
    return '';
  }

  generate() {
    if (this.mappingNameControl.invalid || this.testCasesFileControl.invalid || this.dynamicForm.invalid) {
      return;
    }
    
    this.activeModal.close({
      value: {
        mappingName: this.mappingNameControl.value,
        testCasesFile: this.testCasesFileControl.value,
        file: this.selectedFile,
        ...this.dynamicForm.value
      },
      fields: this.fields,
    });
  }
  
  isFormValid(): boolean {
    return this.mappingNameControl.valid && this.testCasesFileControl.valid && this.dynamicForm.valid;
  }
}
